import React from 'react';
import Dropzone from 'react-dropzone';

const DropZoneComponent = props => (
  <React.Fragment>
    <Dropzone
      onDrop={acceptedFiles => props.uploadedFile(acceptedFiles)}
    >
      {({ getRootProps, getInputProps }) => (
        <section className="main-drop-down-files height-110 margin-left-right-0">
          <div>
            <div {...getRootProps()}>
              <input {...getInputProps()} />
              {props.loadImage
                ? <div><i className="fas fa-spinner fa-pulse font-size-50" /></div>
                : <h5>{props.title}</h5>
            }
            </div>
          </div>
        </section>
      )}
    </Dropzone>
    {props.fileName && <p className="image-banner-url">{props.fileName}</p>}
  </React.Fragment>
);

export default DropZoneComponent;
